import React from 'react'
import { usePredictContext } from '../context/PredictContextProvider'
import LockIcon from '../../../components/icons/LockIcon'
import { Text } from '../../../modules/Dashboard'

const LockedAssistant = () => {
    const { isLocked } = usePredictContext()

    if (!isLocked) return (<></>)

    return (
        <div className='w-full bg-[#FFFFFF4D] backdrop-blur rounded-t-lg py-1 px-2 '>
            <div className='flex items-center justify-center gap-2'>
                <LockIcon size={24} />
                <Text tid={"Unlock With 50% OFF Plan"} className='text-sm sm:text-base' />
            </div>
        </div>
    )
}

export default LockedAssistant